import customCallbackHandler from '../shared/customCallbackHandler';
const touchTap = customCallbackHandler.bind(null, 'Touch', 'touchTapCallback');
export default touchTap;
//# sourceMappingURL=touchTap.js.map